<template>
<el-dialog
      :visible.sync="dialoglogin"
      width="400px"
      :close-on-click-modal="false"
      :before-close="handleClose"
      center
      custom-class="eldiglog"
    >
<div slot="title" class="titles_dig">
 <p>立即预约</p>
</div>
 <div style="width: 85%;margin: 0 auto;">
    <el-form ref="loginRules" :rules="rules" :model="loginForm">
      <el-form-item prop="nickname">
       
            <el-input
          v-model="loginForm.nickname"
          placeholder="请输入您的姓名"
          name="nickname"
          type="text"
          
        />
     
      </el-form-item>

      <el-form-item prop="phone">

            <el-input
          type="text"
          v-model="loginForm.phone"
          placeholder="请输入您的手机号"
          name="phone"
          auto-complete="on"
          @keyup.enter.native="handleLogin"
        />
 
      </el-form-item>

      <div class="dlog_but" style="width: 70%;margin: 0 auto;">
        <el-button
          :loading="loading"
          type="primary"
          style="font-size: 18px; width: 100%;background-color: #3964E6;"
          @click.native.prevent="handleLogin(loginForm)"
     
          >立即预约</el-button
        >
      </div>

    </el-form>
       </div>
    </el-dialog>
</template>
<script>
import {zixunpost} from "@/api/coursedetails"
export default {
    name: 'makedialog',
    data() {
        // 手机号正则验证
        var iphonerouls = (rule, value, callback) => { 
              if(!value){
                  callback(new Error('请输入手机号'));
                  return;
              }

               var pattern = /^1(3[0-9]|4[57]|5[0-9]|7[0135678]|8[0-9])\d{8}$/;
        
               if(!pattern.test(value)){
                  callback(new Error('请输入正确的手机号'));
               }else{
                   callback()
               }

        }
        return {
            loginForm: {
                nickname: '',
                phone: ''
            },
            rules: {
                nickname: [{ required: true, trigger: 'blur', message: "请输入您的姓名" }],
                phone: [{validator:iphonerouls, trigger: 'blur' }]
            },
            loading: false,
         
        }
    },
    props:{
        dialoglogin:{
            type:Boolean
        }
    },
    methods: {
        handleLogin() {
            this.$refs.loginRules.validate(valid => {
console.log(valid,"点击")
                if (valid) {
                     console.log("点击AA")
                    this.loading = true;
                    zixunpost(this.loginForm).then(res=>{
                        if(res.code == 200){
                            this.$message({
                                message:"信息提交成功,请耐心等待!!!",
                                type:"success",
                                offset:150
                            })
                        }
                        this.loading = false;
                        this.$emit("makelogs",false)
                        this.logincanshu();
                    })
                } else {
                    return false;
                }
            })
        },
        //清空数据
        logincanshu() {
            this.loginForm = {
                nickname: '',
                phone: ''
            };
        },
        handleClose() {
          this.$emit("makelogs",false)
        },
        open(){
          
        }
    }
}
</script>
<style  lang="scss">
.eldiglog{
    .el-dialog__header{
        padding: 0 !important;
    }
    .el-dialog__headerbtn i{
        color: #fff !important;
    }
.titles_dig{
    width: 100%;
    height: 51px;
    background-color: #3964E6;
    font-size: 18px;
    color: #fff;
    line-height: 51px;
}
}

</style>

